module.exports = __webpack_public_path__ + "img/preview-3.c39858c8.png";